import template from "../templates/npa_selection_form.jst";

import SortableListView from "shared/components/sortable_list";

import View from "backdraft-app/src/view";

import Collection from "backdraft-app/src/collection";

export default class NpaSelectionForm extends View {
  initialize(options) {
    super.initialize(options);

    this.model = options.model;

    const npaSelection = new SortableListView({
      collection: new Collection([]),
      readOnly: true,
      selection: "radio"
    });

    this.child("npa-selection", npaSelection);
    if (!this.model) {
      throw new Error("model must be provided");
    }
  }

  render() {
    this.$el.html(template({ model: this.model }));
    this.$("[data-mount='npa-selection']").html(this.child("npa-selection").render().$el);

    return this;
  }

  updateCollection(collection) {
    this.child("npa-selection").resetSortableCollection(collection);
  }

  getCollection() {
    return this.child("npa-selection").collection;
  }

  getSelection(model) {
    return this.child("npa-selection").getRadioSelection();
  }

  disableUnavailableNpasAndCheckNextAvailable(selectedNpas) {
    const npaCollection = this.getCollection();
    selectedNpas.forEach(npaId => {
      const npa = npaCollection.findWhere({ id: npaId });

      if (npa) {
        npa.set({ checked: false, disabled: true });
      }
    });

    const nextNpa = npaCollection.find(npaModel => !npaModel.get("disabled"));
    if (nextNpa) {
      this.child("npa-selection").setRadioSelection(nextNpa);
    }
  }
}
